import "./Carousel.scss";
import { useState } from "react";

const Carousel = ({ data }: { data: any[] }) => {
  const [slide, setSlide] = useState(0);

  // const nextSlide = () => {
  //   setSlide(slide === data.length - 1 ? 0 : slide + 1);
  // };

  // const prevSlide = () => {
  //   setSlide(slide === 0 ? data.length - 1 : slide - 1);
  // };

  return (
    <div className="carousel">
      <div>
        {data.map((item, idx) => {
          return (
            <div key={idx}>
              <img
                src={item.image}
                alt={item.name}
                key={idx}
                className={slide === idx ? "slide" : "slide slide-hidden"}
              />
            </div>
          );
        })}
      </div>
      {data.length > 1 && (
        <div className="indicators">
          <span>
            {data.map((_, idx) => {
              return (
                <button
                  key={idx}
                  className={
                    slide === idx ? "indicator" : "indicator indicator-inactive"
                  }
                  onClick={() => setSlide(idx)}
                ></button>
              );
            })}
          </span>
        </div>
      )}
    </div>
  );
};

export default Carousel;
